export function getFromLocalStorage(key, fallback) {
    try {
        const item = localStorage.getItem(key);

        if (!item) {
            return null;
        }

        return JSON.parse(item);
    } catch (error) {
        console.warn(`Error parsing localStorage key "${key}":`, error);
        return fallback;
    }
}

export function setToLocalStorage(key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.warn(`Error setting localStorage key "${key}":`, error);
    }
}
